import { competitionDirectoryReturn } from './competitionReturn'
import CompetitionActions from './CompetitionActions'
import EventStage from '../../../EventStage'
import 'assets/scss/custom/pages/_competitionDirectory.scss'
import { eventDirectoryLocation } from "pages/EventsManagement/directoryQuery"
import React, { useCallback, useState, useEffect, useContext } from "react"
import { useToasts } from "react-toast-notifications"
import { store as socketStore } from "components/Common/Socket/store"
import useDrawOperation from "./Tabs/Draw/useDrawOperation"
import DrawOperationFeedback from "./Tabs/Draw/DrawOperationFeedback"
import { invalidateEventCache } from "../../../eventCachePolicy"
import { tenis10CategoryLabel } from "../../../tenis10Event"

import {
  Container,
  Row,
  Col,
  TabPane,
  TabContent,
  Nav,
  NavItem,
  NavLink,
  Breadcrumb,
  BreadcrumbItem,
} from "reactstrap"

import { Link } from "react-router-dom"
import { connect } from "react-redux"
import classnames from "classnames"

import CompetitionTabs from "./Tabs"
import { getEventDetails as getEventDetailsAction } from "../../../actions"
import {
  EVENT_DETAILS_READ_MODE_COMPETITION,
  EVENT_DETAILS_READ_MODE_SHELL,
  getCompetitionDetailsReadModeForTab,
} from "../../../eventDetailsReadPolicy"

const Competition = ({ getEventDetails, eventDetails, userDetails, competitionReadError, ...props }) => {
  const [actionRefresh, setActionRefresh] = useState(0)

  const { id, competitionId } = props.match.params

  const activeTab = props.match.params.tab || "details"
  const hasSelectedCompetition = /^[a-f0-9]{24}$/i.test(competitionId || "")
  const competitionDetailsReadMode = hasSelectedCompetition
    ? getCompetitionDetailsReadModeForTab(activeTab)
    : EVENT_DETAILS_READ_MODE_SHELL
  const selectedCompetitionId =
    competitionDetailsReadMode === EVENT_DETAILS_READ_MODE_COMPETITION
      ? competitionId
      : undefined
  const refreshEventDetails = useCallback(
    (eventId = id) =>
      getEventDetails(eventId, competitionDetailsReadMode, selectedCompetitionId),
    [competitionDetailsReadMode, getEventDetails, id, selectedCompetitionId]
  )

  const refreshAll = useCallback(() => {
    invalidateEventCache({ eventId: id, competitionId })
    refreshEventDetails(id)
    setActionRefresh(value => value + 1)
  }, [id, competitionId, refreshEventDetails])
  const { state: { socket: { socket, socketClientId } = {} } = {} } = useContext(socketStore)
  const { addToast } = useToasts()
  const drawOperation = useDrawOperation({ eventId: id, competitionId, userId: userDetails?.id || userDetails?._id,
    socket, socketClientId, refresh: refreshAll, addToast, enabled: hasSelectedCompetition })
  useEffect(() => {
    refreshEventDetails(id)
  }, [id, refreshEventDetails])

  const [event] = eventDetails || []

  const [competitionDetails] =
    (event && event.competitions?.filter(({ _id }) => _id === competitionId)) ||
    []

  const returnTo = competitionDirectoryReturn(props.location, id)

  const ActiveTab = CompetitionTabs?.filter(({ url }) => url === activeTab)[0].Component

  return (
    <div className="page-content competition-page">
      <Container fluid>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to={eventDirectoryLocation()}>Events</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to={returnTo}>
              Event: {event?.name}{" "}
            </Link>
          </BreadcrumbItem>

          {competitionDetails?._id ? (
            <BreadcrumbItem active>
              Competition: {competitionDetails?.competitionId}{" "}
            </BreadcrumbItem>
          ) : (
            <BreadcrumbItem active>Create New Competition</BreadcrumbItem>
          )}
        </Breadcrumb>

        <div className="d-flex flex-wrap justify-content-between">
          <div>
            {competitionDetails ? (
              <h4>
                {"Edit Competition" +
                  " Id: " +
                  competitionDetails?.competitionId}{" "}
                {` - ${competitionDetails?.tenis10Level ? tenis10CategoryLabel(competitionDetails) : `Level ${competitionDetails?.level}`} - ${competitionDetails?.gameType} `}
                (
                {competitionDetails?.status === "ACCEPTED" ||
                competitionDetails?.status === "CREATED"
                  ? "ACTIVE"
                  : competitionDetails?.status === "MAINTENANCE"
                  ? "MAINTENANCE"
                  : "INACTIVE"}
                )
              </h4>
            ) : (
              <h4>Create Competition</h4>
            )}
          </div>

          {id && <EventStage stage={event?.currentPhase?.status} />}
        </div>
      
        {/* if we have a competition id display tabs for details and entries*/}
        <div className="tabs">
          {competitionId && (
            <Nav className="mb-0 d-flex justify-content-between" pills>
              <div className="d-flex flex-wrap">
                {CompetitionTabs.map(({ label, url }) => {
                  return (
                    <NavItem key={label}>
                      <NavLink
                        className={classnames({
                          active: activeTab === url,
                        })}
                        tag={Link}
                        to={{ pathname: `/events/${id}/competitions/${competitionId}/${url}`, state: { competitionReturnTo: returnTo } }}
                        aria-current={activeTab === url ? "page" : undefined}
                      >
                        {label}
                      </NavLink>
                    </NavItem>
                  )
                })}
              </div>
              {activeTab !== "details" && <CompetitionActions id={id} competitionId={competitionId} userDetails={userDetails} returnTo={returnTo} onSaved={refreshAll} refreshVersion={actionRefresh} />}
            </Nav>
          )}
          <TabContent activeTab={activeTab} className="competition-tab-content">
            {activeTab !== "entries" && <DrawOperationFeedback operation={drawOperation} competition={competitionDetails} />}
            {activeTab !== "draw" && competitionReadError?.eventId === id && competitionReadError?.competitionId === competitionId &&
              <div className="alert alert-danger" role="alert">
                Competition data could not be refreshed. The displayed data may be out of date.{" "}
                <button className="btn btn-link" onClick={refreshAll}>Retry competition data</button>
              </div>}
            <TabPane tabId={activeTab}>
              <Row>
                <Col sm="12">
                  <ActiveTab
                    drawOperation={drawOperation}
                    drawReadRevision={actionRefresh}
                    eventDetails={eventDetails[0]}
                    competitionDetails={competitionDetails}
                    getEventDetails={refreshAll}
                    userDetails={userDetails}
                    managementActions={hasSelectedCompetition && activeTab === "details" ? <CompetitionActions id={id} competitionId={competitionId} userDetails={userDetails} returnTo={returnTo} onSaved={refreshAll} refreshVersion={actionRefresh} inlinePdf /> : null}
                    id={id}
                    match={props.match}
                    history={props.history}
                  />
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </div>

      </Container>
    </div>
  )
}

const mapStateToProps = ({ events: { eventDetails = [], competitionReadError } = {}, session: { userDetails } = {} }) => ({
  eventDetails,
  competitionReadError,
  userDetails,
})

export default connect(mapStateToProps, {
  getEventDetails: getEventDetailsAction,
})(Competition)
